import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { LoaderService } from '@tmhcc-ng-lib/framwork/loader';
import { ActivatedRoute, Router } from '@angular/router';
import { has, isNullUndefinedEmptyOrWhiteSpace } from '@tmhcc/util';
import { FormBuilder } from '@angular/forms';
import { AppConfigService } from '@tmhcc-ng-lib/global-services';
import {
  DialogConfig,
  DialogFlag,
  DialogRef
} from '@tmhcc-ng-lib/framwork/dialog';
import {
  DocumentService,
  FormBuildService,
  GetCorePageDataService,
  GlobalVariablesService,
  AppDataService,
  StepsService
} from '@tmhcc-ng-lib/data-service';
import { BaseUCMFormsComponent } from '../base-ucm-forms.component';
import { UCMSharedService } from '../ucm-shared.service';
import { UCMEventName } from '@tmhcc-ng-lib/models';
import { AutoDeclineService } from '../../common-liability/auto-decline/auto-decline.service';
import { AccordionService } from '../../accordion-menu/accordion.service';

@Component({
  selector: 'ac-ucm-dialog',
  templateUrl: './ucm-dialog.component.html',
  styleUrls: ['./ucm-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UCMDialogComponent extends BaseUCMFormsComponent
  implements OnInit, OnDestroy {
  apiEndpoint: string;
  apiKey: string;

  constructor(
    protected router: Router,
    protected globalVariables: GlobalVariablesService,
    protected getSiteCoreDataService: GetCorePageDataService,
    protected ucmService: UCMSharedService,
    protected formBuildService: FormBuildService,
    protected loaderService: LoaderService,
    protected activeRouter: ActivatedRoute,
    protected documentService: DocumentService,
    protected appDataService: AppDataService,
    private formBuilder: FormBuilder,
    protected configService: AppConfigService,
    private dialogConfig: DialogConfig,
    private dialogRef: DialogRef,
    protected accordionService: AccordionService,
    protected stepsService: StepsService,
    protected autoDeclineService: AutoDeclineService
  ) {
    super(
      router,
      globalVariables,
      getSiteCoreDataService,
      ucmService,
      formBuildService,
      loaderService,
      activeRouter,
      documentService,
      appDataService,
      autoDeclineService,
      stepsService,
      accordionService,
      configService
    );
    this.apiEndpoint = this.configService.config.dataServiceBaseUrl;
    this.apiKey = this.configService.config.dataServiceApiKey;
  }

  ngOnInit(): void {
    this.loaderService.show();
    this.setElementDefault();
    this.initFormGroup();
    this.loadUCMPage();
  }

  initFormGroup() {
    const controls = {};
    this.ucmFormGroup = this.formBuilder.group(controls);
  }
  loadUCMPage() {
    this.isFormRendered = false;
    if (has(this.dialogConfig.data, 'formID')) {
      this.ucmSLFormId = this.dialogConfig.data.formID;
      super.renderUCM(this.dialogConfig.data.formID);
    }
  }

  onFormEvent(event) {
    super.onFormEvent(event);
    if (event.eventName === UCMEventName.Cancel) {
      this.dialogRef.close();
    } else if (
      //event.eventName === UCMEventName.PreviewForm ||
      event.eventName === UCMEventName.SaveAndSend ||
      event.eventName === UCMEventName.InsuredNextClick ||
      event.eventName === UCMEventName.Step4DwnloadDoc
    ) {
      this.dialogRef.close(DialogFlag.ReloadRequired);
    } else if (event.eventName === UCMEventName.DownloadAndSign) {
      this.dialogRef.close();
    }

    if (
      event.eventName === UCMEventName.StartNewEndorsement ||
      event.eventName === UCMEventName.CancelEndorsement ||
      event.eventName === UCMEventName.CreateEndorsement ||
      event.eventName === UCMEventName.ContinueEndorsement
    ) {
      this.dialogRef.close(event);
    }
  }
  backNevigation() {}
  nextNevigation() {}
  ngOnDestroy() {}

  setElementDefault() {
    super.setElementDefault();

    if (
      has(this.dialogConfig.data, 'currentPolicyNum') &&
      !isNullUndefinedEmptyOrWhiteSpace(this.dialogConfig.data.currentPolicyNum)
    ) {
      this.elementDefaults.policyMaster = this.dialogConfig.data.currentPolicyNum;
    }

    if (
      has(this.dialogConfig.data, 'priorPolicyNum') &&
      !isNullUndefinedEmptyOrWhiteSpace(this.dialogConfig.data.priorPolicyNum)
    ) {
      this.elementDefaults.policyTxnNumPrior = this.dialogConfig.data.priorPolicyNum;
    }
  }
}
